// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBBkt_fBhPZo93zc4172IH2n6RrWGzwBpw",
  authDomain: "afteru-544e7.firebaseapp.com",
  projectId: "afteru-544e7",
  storageBucket: "afteru-544e7.firebasestorage.app",
  messagingSenderId: "831265838034",
  appId: "1:831265838034:web:924679229ae16b1d456e0b",
  measurementId: "G-42NJ3PFMNQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
